@if (details) {
  <div class="summary-container">
    <div class="summary-details">
      <p class="ui-body-m-bold summary-details-item">Booking Details:</p>
      <div class="summary-details-item">
        <rds-icon namespace="outlined" icon="flag" class="icon" />
        <div>
          <p class="ui-body-s-bold">Event Name:</p>
          <p class="ui-body-m">
            {{ details.eventName }}
          </p>
        </div>
      </div>
      <div class="summary-details-item">
        <rds-icon namespace="outlined" icon="calendar" class="icon" />
        <div>
          <p class="ui-body-s-bold">Date & Time:</p>
          <p class="ui-body-m">
            {{ details.startTime | eventDateTime: details.endTime }}
          </p>
        </div>
      </div>
      @if (details.additionalInfo) {
        <div class="summary-details-item">
          <rds-icon namespace="outlined" icon="circle_info" class="icon" />
          <div>
            <p class="ui-body-s-bold">Additional Information</p>
            <p class="ui-body-m">
              {{ details.additionalInfo }}
            </p>
          </div>
        </div>
      }
      @if (showGeneralQuestions === true) {
        <div class="summary-details-item">
          <rds-icon namespace="outlined" icon="circle_help" class="icon" />
          <div class="me-7">
            <p class="ui-body-s-bold">CEC on site?</p>
            <p class="ui-body-m">
              {{ details.generalQuestions.cecOnSite ? 'Yes' : 'No' }}
            </p>
          </div>
          <div class="me-7">
            <p class="ui-body-s-bold">HCP on site?</p>
            <p class="ui-body-m">
              {{ details.generalQuestions.hcpOnSite ? 'Yes' : 'No' }}
            </p>
          </div>
          <div class="me-7">
            <p class="ui-body-s-bold">More than 20 Externals?</p>
            <p class="ui-body-m">
              {{ details.generalQuestions.moreThan20Externals ? 'Yes' : 'No' }}
            </p>
          </div>
        </div>
      }
      <div class="summary-details-item">
        <rds-avatar size="m" class="icon">
          @if (details.requester.photo) {
            <img
              rds-avatar-image
              [ngSrc]="details.requester.photo"
              fill
              referrerpolicy="no-referrer"
              alt="user image" />
          } @else {
            <rds-icon rds-avatar-icon namespace="outlined" icon="user" />
          }
        </rds-avatar>
        <div>
          <p class="ui-body-s-bold">Requester:</p>
          <p class="ui-body-m">
            {{
              details.requester.fullName + ' (' + details.requester.email + ')'
            }}
          </p>
        </div>
      </div>
      @for (onBehalf of details.onBehalfParticipants; track onBehalf.email) {
        <div class="summary-details-item">
          <rds-avatar size="m" class="icon">
            @if (onBehalf.photo) {
              <img
                rds-avatar-image
                [ngSrc]="onBehalf.photo"
                fill
                referrerpolicy="no-referrer"
                alt="user image" />
            } @else {
              <rds-icon rds-avatar-icon namespace="outlined" icon="user" />
            }
          </rds-avatar>
          <div>
            <p class="ui-body-s-bold">On behalf:</p>
            <p class="ui-body-m">
              {{
                onBehalf.fullName !== undefined
                  ? onBehalf.fullName + ' (' + onBehalf.email + ')'
                  : onBehalf.email
              }}
            </p>
          </div>
        </div>
      }
    </div>
    @if (selectedServices.length > 0) {
      <div class="summary-services">
        <p class="ui-body-m-bold summary-details-item">
          Based on your Additional Service Requests you can now complete the
          following:
        </p>
        @for (item of selectedServices; track item.service) {
          <div class="summary-details-item">
            <rds-custom-icon
              [icon]="item.customIcon"
              class="icon"></rds-custom-icon>
            <div>
              <p class="ui-body-s-bold">{{ item.name }}</p>
              @if (item.isUrl) {
                @if (item.ticketName) {
                  <a
                    class="ui-body-m me-3"
                    [href]="item.description"
                    target="_blank">
                    {{ item.ticketName }}
                  </a>
                  <rds-badge
                    size="m"
                    [label]="item.ticketStatus ?? 'unknown'"
                    color="neutral"></rds-badge>
                } @else {
                  <a
                    class="ui-body-m"
                    [href]="item.description"
                    target="_blank">
                    Request here
                  </a>
                }
              } @else {
                <p class="ui-body-m">{{ item.description }}</p>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
